// Thin composition layer - re-exports from focused sub-modules
import {
  isValidDateString, converDateToYMDFormat, getNumberWithTwoDigitsAfterDecimal,
  getPlannedCost, getUnits, getAdFee, getRate, getAdServerFee,
  getAdVerificationFee, getDimensions, getStaticField
} from './placement-formatters';

import {
  exportPlacements, checkExportJobStatus, importPlacements, sortPlacements,
  sendToMediaOcean, getPlacementsApproved, getPlacementsApprovedChunked,
  bulkPlacementsCopy, getPlacementsWithDelivered, getPlacementsWithDeliveredCached,
  deletePlacement, downloadPlacementTemplate, uploadPlacementTemplate
} from './placement-detail-api';

import {
  splitPlacementStringIntoSchemaObject, splitStringIntoArray,
  createArrayFromJson, createStringFromJson, createStringFromArray,
  createTemplateString, buildTaxonomyStrings, createformDataForEditPlacement,
  updateFormDataWithJsonData, getFormEditData, compareTaxonomyAndData,
  getDefaultValuesForParameterCode, getErrorMessage,
  getSynthecticId, setSynthecticId
} from './placement-taxonomy';

import {
  prepareCopyPayload, getOmniIconDisableOptions, copyTextToClipboard,
  createEmptyChannelsData, convertToNestedStructure, removeKey,
  getDate, removeEmptyNestedData, getPublisherFees, getChannelFees,
  getSelectedTier, updateParentTier, isEditableInlineParameterCode,
  onPlacementCopySuccess, onPlacementCopyFailure
} from './placement-data-helpers';

// backward-compatible service object
export const PlacementDetailsTableService = {
  // formatters
  isValidDateString,
  converDateToYMDFormat,
  getNumberWithTwoDigitsAfterDecimal,
  getPlannedCost,
  getUnits,
  getAdFee,
  getRate,
  getAdServerFee,
  getAdVerificationFee,
  getDimensions,
  getStaticField,

  // api
  exportPlacements,
  checkExportJobStatus,
  importPlacements,
  sortPlacements,
  sendToMediaOcean,
  getPlacementsApproved,
  getPlacementsApprovedChunked,
  bulkPlacementsCopy,
  getPlacementsWithDelivered,
  getPlacementsWithDeliveredCached,
  deletePlacement,
  downloadPlacementTemplate,
  uploadPlacementTemplate,

  // taxonomy
  splitPlacementStringIntoSchemaObject,
  splitStringIntoArray,
  createArrayFromJson,
  createStringFromJson,
  createStringFromArray,
  createTemplateString,
  buildTaxonomyStrings,
  createformDataForEditPlacement,
  updateFormDataWithJsonData,
  getFormEditData,
  compareTaxonomyAndData,
  getDefaultValuesForParameterCode,
  getErrorMessage,

  // synthecticId proxy
  get synthecticId() { return getSynthecticId(); },
  set synthecticId(val) { setSynthecticId(val); },

  // data helpers
  prepareCopyPayload,
  getOmniIconDisableOptions,
  copyTextToClipboard,
  createEmptyChannelsData,
  convertToNestedStructure,
  removeKey,
  getDate,
  removeEmptyNestedData,
  getPublisherFees,
  getChannelFees,
  getSelectedTier,
  updateParentTier,
  isEditableInlineParameterCode,
  onPlacementCopySuccess,
  onPlacementCopyFailure,
};
